export class ApiError extends Error {
	constructor(
		message?: string,
		public status?: number
	) {
		let fullMessage = 'API error';
		if (message) {
			fullMessage += `: ${message}`;
		}

		super(fullMessage);

		if (status) {
			this.status = status;
		}
	}
}
